import type { ReactNode } from 'react'

interface DataTableToolbarProps {
  children: ReactNode
  actions?: ReactNode
}

export function DataTableToolbar({ children, actions }: DataTableToolbarProps) {
  return (
    <div className="mb-4 flex flex-wrap items-start gap-3">
      <div className="flex flex-1 flex-wrap items-end gap-2">{children}</div>
      {actions ? <div className="flex items-center gap-2 shrink-0">{actions}</div> : null}
    </div>
  )
}
